import React from "react";
import { Box, Button, Dialog, Stack } from "@origin-digital/ods-core";
import { CloseTransferWarningModalMessageType } from "../types";
import { CloseTransferWarningDialogProps } from "./types";
import { useCloseTransferWarningDialogContext } from "./context";
import {
  CloseTransferWarningMessageContentNotRequired,
  CloseTransferWarningMessageContentProcessed,
} from "./CloseTransferWarningMessageContent";

export const CloseTransferWarningDialog = ({
  onUpdate,
  warningMessageType,
}: CloseTransferWarningDialogProps) => {
  const { closeDialog, id } = useCloseTransferWarningDialogContext();
  const onUpdateStatus = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation();
    onUpdate();
    closeDialog();
  };

  return (
    <Dialog id={id} open={true} title="Are you sure?" hideClose={true}>
      <Stack space="small">
        {/* Content */}
        {warningMessageType ==
          CloseTransferWarningModalMessageType.NOT_REQUIRED && (
          <CloseTransferWarningMessageContentNotRequired />
        )}
        {warningMessageType ==
          CloseTransferWarningModalMessageType.PROCESSED && (
          <CloseTransferWarningMessageContentProcessed />
        )}
        {/* End Content */}

        {/* Actions */}
        <Box
          position={{
            lg: "static",
            xs: "fixed",
          }}
          paddingTop={{
            lg: "medium",
            xs: "medium",
          }}
          paddingBottom={{
            lg: "none",
            xs: "large",
          }}
          paddingX={{
            lg: "none",
            xs: "medium",
          }}
          backgroundColor="white"
          width="full"
          style={{
            left: "0",
            bottom: "0",
            zIndex: "1",
          }}
        >
          <Box
            display="flex"
            flexWrap={{
              lg: "nowrap",
              xs: "wrap",
            }}
            justifyContent="flex-end"
            alignItems="center"
          >
            <Box marginRight="large">
              <Button variant="text" color="primary" onClick={closeDialog}>
                Cancel
              </Button>
            </Box>
            <Button onClick={(e) => onUpdateStatus(e)}>Update status</Button>
          </Box>
        </Box>
        {/* End Actions */}
      </Stack>
    </Dialog>
  );
};
